import { css } from 'lit';

export const style = css`
  .button-container {
    margin-top: 1em;
    text-align: center;
  }

  .card-button {
    margin-top: 24px;
    width: 100%;

    @media (min-width: 768px) {
      display: flex;
      margin-left: auto;
      margin-right: auto;
      width: fit-content;
    }
  }
`;
